import type { ExportResult } from './client';
import type { SettingsApi } from './settings.types';

type Call = <T>(method: string, path: string, body?: unknown) => Promise<T>;

/** Implémentation REST des endpoints étendus de la zone Paramètres (voir openapi-notes.md). */
export function createSettingsHttp(call: Call, o: (org: string) => string): SettingsApi {
  return {
    getIntegrationConfig: (org, kind) => call('GET', `${o(org)}/integrations/${kind}/config`),
    saveIntegrationConfig: (org, kind, input) => call('PUT', `${o(org)}/integrations/${kind}/config`, input),
    testIntegration: (org, kind) => call('POST', `${o(org)}/integrations/${kind}/test`),

    listWebhooks: (org) => call('GET', `${o(org)}/webhooks`),
    createWebhook: (org, input) => call('POST', `${o(org)}/webhooks`, input),
    updateWebhook: (org, id, patch) => call('PATCH', `${o(org)}/webhooks/${id}`, patch),
    rotateWebhookSecret: (org, id) => call('POST', `${o(org)}/webhooks/${id}/rotate-secret`),
    deleteWebhook: (org, id) => call('DELETE', `${o(org)}/webhooks/${id}`),
    listWebhookDeliveries: (org, id) => call('GET', `${o(org)}/webhooks/${id}/deliveries`),
    replayWebhookDelivery: (org, id, deliveryId) => call('POST', `${o(org)}/webhooks/${id}/deliveries/${deliveryId}/replay`),

    listRecipes: (org) => call('GET', `${o(org)}/recipes`),
    createRecipe: (org, input) => call('POST', `${o(org)}/recipes`, input),
    updateRecipe: (org, id, input) => call('PATCH', `${o(org)}/recipes/${id}`, input),
    deleteRecipe: (org, id) => call('DELETE', `${o(org)}/recipes/${id}`),
    importRecipe: (org, libraryId) => call('POST', `${o(org)}/recipes/import`, { libraryId }),
    submitRecipe: (org, id) => call('POST', `${o(org)}/recipes/${id}/submit`),
    reviewRecipe: (org, id, decision) => call('POST', `${o(org)}/recipes/${id}/review`, { decision }),
    startRollout: (org, id, failureThresholdPct) => call('POST', `${o(org)}/recipes/${id}/rollout`, { failureThresholdPct }),
    advanceRollout: (org, id) => call('POST', `${o(org)}/recipes/${id}/rollout/advance`),
    haltRollout: (org, id) => call('POST', `${o(org)}/recipes/${id}/rollout/halt`),

    listKbDocuments: (org) => call('GET', `${o(org)}/knowledge/documents`),
    addKbDocument: (org, input) => call('POST', `${o(org)}/knowledge/documents`, input),
    retryKbDocument: (org, id) => call('POST', `${o(org)}/knowledge/documents/${id}/retry`),
    deleteKbDocument: (org, id) => call('DELETE', `${o(org)}/knowledge/documents/${id}`),

    getDomainVerification: (org) => call('GET', `${o(org)}/settings/domain-verification`),
    verifyCustomDomain: (org) => call('POST', `${o(org)}/settings/domain-verification`),

    exportOrganizationData: (org) => call<ExportResult>('POST', `${o(org)}/export`),
    deleteOrganization: (org, req) => call('POST', `${o(org)}/delete`, req),
  };
}
